import { getToken } from "../cookie/authCookie";
import axiosInstance from "./config/axiosConfigs";

export const ClubAPI = {

  registerClub: async function (clubRegistration) {
    const response = await axiosInstance.request({
      url: `/register/club`,
      method: "POST",
      data: clubRegistration,
      timeout: 80000,
    });
    return response.data;
  },

  fetchAllClubs: async function (clubName) {
    const response = await axiosInstance.request({
      url: `/register/club/all`,
      method: "POST",
      data: clubName,
      timeout: 8000,
    });
    return response.data;
  },
  
  fetchAllClubsByUser: async function (userId) {
    const response = await axiosInstance.request({
      url: `/club/get-all-club/${userId}`,
      method: "GET",
      timeout: 8000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data;
  },
  fetchAllJoinRequests: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/club/get-all-requests/${clubId}`,
      method: "GET",
      timeout: 8000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data;
  },
  sendClubJoinRequest: async function (userInfo) {
    const response = await axiosInstance.request({
      url: `/club/join`,
      method: "POST",
      data: userInfo,
      timeout: 8000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data;
  },
  joinRequestAction: async function (reqInfo) {
    const response = await axiosInstance.request({
      url: `/club/accept-requests`,
      method: "POST",
      data: reqInfo,
      timeout: 8000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data;
  },
  updateClubDetails: async function (clubInfo, clubLogo, clubId) {
    let formData = new FormData();
    formData.append("clubLogo", clubLogo);
    formData.append("clubInfo", JSON.stringify(clubInfo));
    const response = await axiosInstance.request({
      url: `/club/update/${clubId}`,
      method: "POST",
      data: formData,
      // timeout: 2000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data
  },
 
  updateClubLogo: async function (clubInfo) {
    let formData = new FormData();
    formData.append('clubLogo', clubInfo.clubLogo);
    const response = await axiosInstance.request({
      url: `/club/upload-logo/${clubInfo.clubId}`,
      method: "POST",
      data: formData,
      // timeout: 8000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

};